import { TNavigationBlockerViaHistoryMethodsRef, TWAction } from '@libs/types';
import { useEffect, useEffectEvent } from 'react';

export const addHistory = (action: TWAction) => {
    window.history.pushState({ action: action }, '');
};

export const useNavigationBlockerViaHistory = (shouldBlock: boolean, methodsRef: TNavigationBlockerViaHistoryMethodsRef) => {
    const { triggerAction, systemActionNavigateBack } = methodsRef;

    const handlePopState = useEffectEvent((event: PopStateEvent) => {
        event.preventDefault();
        if (shouldBlock && systemActionNavigateBack) {
            triggerAction(systemActionNavigateBack.action, { widgetAction: systemActionNavigateBack.widget }).then();
        }
    });

    useEffect(() => {
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);
};
